// extracted by mini-css-extract-plugin
module.exports = {"btnAddAnimal":"AnimalCreate_btnAddAnimal__1V7SO","textHeaderAddAnimal":"AnimalCreate_textHeaderAddAnimal__2o_Vy","btnCancelAddAnimal":"AnimalCreate_btnCancelAddAnimal__2Kt8z"};